import { Flex, Text } from '@chakra-ui/react';
import React from 'react';

export const Section = ({ title, children }) => (
    <Flex gap="20px" direction="column" mb="32px">
        <Text fontWeight="700">{title}</Text>
        {children}
    </Flex>
);
